export default __webpack_public_path__ + "static/media/icon-info-participation-fees-2.ba3a8de1.svg";